import masterDataService from '../service/masterData.service';

export const itemAutocompleteService = (requestBody) => masterDataService.searchItemsForAutocomplete(requestBody);

export const itemAutocompleteRequestBuilder = ({ searchText, selectedValue, pageSize, mode, searchMode, props }) => {
  const explicitApplyItemGroupFilter = props?.applyItemGroupFilter;
  const selectedRawValue =
    selectedValue ??
    props?.selectedValue ??
    (props?.value && typeof props.value === 'object' ? props.value.value : null);
  const normalizedSelectedValue =
    selectedRawValue && typeof selectedRawValue === 'object' ? selectedRawValue?.value ?? null : selectedRawValue;
  const normalizedSearchText = String(searchText ?? '').trim();
  const fallbackSearchText =
    mode === 'resolveSelectedValue'
      ? normalizedSearchText || String(normalizedSelectedValue ?? '').trim()
      : normalizedSearchText;

  if (!fallbackSearchText) {
    return null;
  }

  const applyItemGroupFilter =
    typeof explicitApplyItemGroupFilter === 'boolean' ? explicitApplyItemGroupFilter : mode !== 'resolveSelectedValue';

  if (mode === 'resolveSelectedValue') {
    return {
      searchText: fallbackSearchText,
      selectedValue: normalizedSelectedValue || fallbackSearchText,
      pageSize: 1,
      applyItemGroupFilter,
    };
  }

  return {
    searchText: fallbackSearchText,
    pageSize,
    archive: 'N',
    applyItemGroupFilter,
    searchMode,
  };
};

itemAutocompleteRequestBuilder.supportsSearchMode = true;
